// extracted by mini-css-extract-plugin
export default {"document":"LegalDocument_document__L7R+t","date":"LegalDocument_date__M+SaZ","links":"LegalDocument_links__t0RNI","section":"LegalDocument_section__Xw63s"};